import React, { useEffect, useState } from "react";
import { IoIosArrowForward } from "react-icons/io";
import solo from "../../assets/icons/solo.svg";
import creator from "../../assets/icons/creator.svg";
import agency from "../../assets/icons/agency.svg";
import check from "../../assets/icons/RadioCheckedBoxIcon.svg";
import PrimaryButton from "../../components/PrimaryButton";
import Circlebtn from "../../components/Circlebtn";
import { FiMinus } from "react-icons/fi";
import { FaPlus } from "react-icons/fa6";
import { useLocation } from "react-router-dom";
import { useRedirect } from "../../hooks/useRedirect";

const AmountOf = ({label, subLabel, black}: {label: string, subLabel: string, black?: boolean}) => {
  return (
    <div className="flex items-center justify-between px-4 my-3">
      <div>
        <p className={`${black ? "text-white" : "text-[#0F0C18]"} text-xs font-medium tracking-tight`}>{label}</p>
        <p className={`opacity-60 ${black ? "text-white" : "text-[#0F0C18]"} text-xs font-medium tracking-tight mt-1`}>{subLabel}</p>
      </div>
      <div className="flex items-center gap-3.5">
        <Circlebtn className={`${black ? "bg-[#3f3f3f]" : "bg-[#EAE9EF]"} w-8 h-8`} icon={<FiMinus className={`${black ? "text-[#FFFFFF]" : "text-[#0F0C18]"}`} />} />
        <p className={`${black ? "text-white" : "text-[#0F0C18]"} text-xs font-medium tracking-tight`}>5</p>
        <Circlebtn className={`${black ? "bg-[#3f3f3f]" : "bg-[#EAE9EF]"} w-8 h-8`} icon={<FaPlus className={`${black ? "text-[#FFFFFF]" : "text-[#0F0C18]"}`} />} />
      </div>
    </div>
  );
}

const Monthly = () => {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <div className="w-[380px] h-[500px] rounded-xl bg-white relative">
        <div className="p-4">
          <div className="flex items-start justify-between">
            <img src={solo} alt="solo" />
            <p className="text-[#0F0C18] text-base font-medium leading-none tracking-tight">$ 29/month</p>
          </div>
          <h1 className="text-[#0F0C18] text-xl font-medium tracking-tight mt-2">Solo</h1>
          <p className="text-[#9392A2] text-xs font-medium leading-[18px] tracking-tight mt-1">For independent creators seeking flexibility, our solo plan is <br /> tailored just for you. Create 1-3 profile topic groups, <br /> enjoy access to 1 custom voice, and manage your content <br/>effortlessly without the need for a team.</p>
        </div>
        <hr />
        <div className="p-4">
          <div className="flex items-center gap-1.5 mb-3">
            <img src={check} alt="" />
            <p className="text-[#0F0C18] text-xs font-medium tracking-tight">Flexibility for solo users</p>
          </div>
          <div className="flex items-center gap-1.5 mb-3">
            <img src={check} alt="" />
            <p className="text-[#0F0C18] text-xs font-medium tracking-tight">Create 1-3 profile topic groups</p>
          </div>
          <div className="flex items-center gap-1.5 mb-3">
            <img src={check} alt="" />
            <p className="text-[#0F0C18] text-xs font-medium tracking-tight">Access to 1 custom voice</p>
          </div>
          <div className="flex items-center gap-1.5">
            <img src={check} alt="" />
            <p className="text-[#0F0C18] text-xs font-medium tracking-tight">No team collaboration</p>
          </div>
        </div>
        <hr />
        <div>
          <PrimaryButton label="Subscribe for $29/month" className="rounded-3xl py-2.5 mx-4 absolute w-[347px] bottom-4" black />
        </div>
      </div>
      <div className="w-[380px] h-[500px] rounded-xl bg-[#2A2A36] relative">
        <div className="p-4">
          <div className="flex items-start justify-between">
            <img src={creator} alt="creator" />
            <p className="text-white text-base font-medium leading-none tracking-tight">$ 69/month</p>
          </div>
          <h1 className="text-white text-xl font-medium tracking-tight mt-2">Creator</h1>
          <p className="text-[#ffffff9c] text-xs font-medium leading-[18px] tracking-tight mt-1">Elevate content creation game with our Creator plan. All <br /> the perks of the Individual plan, plus the ability to create <br /> 3-5 profile topic groups, unlock 5 custom voices, and <br /> collaborate with your team.</p>
        </div>
        <div className="w-full h-[1px] bg-[#e1e1e159]" />
        <div className="p-4">
          <div className="flex items-center gap-1.5 mb-3">
            <img src={check} alt="" />
            <p className="text-white text-xs font-medium tracking-tight">All features in the Individual plan</p>
          </div>
          <div className="flex items-center gap-1.5 mb-3">
            <img src={check} alt="" />
            <p className="text-white text-xs font-medium tracking-tight">Create 3-5 profile topic groups</p>
          </div>
          <div className="flex items-center gap-1.5 mb-3">
            <img src={check} alt="" />
            <p className="text-white text-xs font-medium tracking-tight">Unlock 5 custom voices</p>
          </div>
          <div className="flex items-center gap-1.5">
            <img src={check} alt="" />
            <p className="text-white text-xs font-medium tracking-tight">Ability to collaborate with a team</p>
          </div>
        </div>
        <div className="w-full h-[1px] bg-[#e1e1e159]" />
        <div>
          <AmountOf label="Amount of user seat" subLabel="$10/seat" black />
          <AmountOf label="Amount of channels" subLabel="$6/per channel" black />
          <PrimaryButton label="Subscribe for $69/month" className="rounded-3xl py-2.5 mx-4 absolute w-[347px] bottom-4" />
        </div>
      </div>
      <div className="w-[380px] h-[500px] rounded-xl bg-white relative">
        <div className="p-4">
          <div className="flex items-start justify-between">
            <img src={agency} alt="agency" />
            <p className="text-[#0F0C18] text-base font-medium leading-none tracking-tight">$ 199/month</p>
          </div>
          <h1 className="text-[#0F0C18] text-xl font-medium tracking-tight mt-2">Agency</h1>
          <p className="text-[#9392A2] text-xs font-medium leading-[18px] tracking-tight mt-1">Designed for agencies with diverse content needs, our <br /> Agency plan offers unlimited profile connections and <br /> access to multiple custom voices. Manage & optimize <br /> content across all profiles.</p>
        </div>
        <hr />
        <div className="p-4">
          <div className="flex items-center gap-1.5 mb-3">
            <img src={check} alt="" />
            <p className="text-[#0F0C18] text-xs font-medium tracking-tight">All features in the Creator plan</p>
          </div>
          <div className="flex items-center gap-1.5 mb-3">
            <img src={check} alt="" />
            <p className="text-[#0F0C18] text-xs font-medium tracking-tight">No limit on profile connections</p>
          </div>
          <div className="flex items-center gap-1.5 mb-3">
            <img src={check} alt="" />
            <p className="text-[#0F0C18] text-xs font-medium tracking-tight">Access to multiple custom voices</p>
          </div>
          <div className="flex items-center gap-1.5">
            <img src={check} alt="" />
            <p className="text-[#0F0C18] text-xs font-medium tracking-tight">Managing diverse profiles</p>
          </div>
        </div>
        <hr />
        <div>
          <AmountOf label="Amount of user seat" subLabel="$10/seat" />
          <AmountOf label="Amount of channels" subLabel="$6/per channel" />
          <PrimaryButton label="Select and subscribe $199/month" className="rounded-3xl py-2.5 mx-4 absolute w-[347px] bottom-4" black />
        </div>
      </div>
  </div>
  );
}

const Annualy = () => {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <div className="w-[380px] h-[500px] rounded-xl bg-white relative">
        <div className="p-4">
          <div className="flex items-start justify-between">
            <img src={solo} alt="solo" />
            <div>
              <p className="text-[#0F0C18] text-base font-medium leading-none tracking-tight">$ 20/month</p>
              <p className="text-[#9392A2] text-xs font-medium text-right mt-1 line-through tracking-tight">$ 29/month</p>
            </div>
          </div>
          <h1 className="text-[#0F0C18] text-xl font-medium tracking-tight mt-2">Solo</h1>
          <p className="text-[#9392A2] text-xs font-medium leading-[18px] tracking-tight mt-1">For independent creators seeking flexibility, our solo plan is <br /> tailored just for you. Create 1-3 profile topic groups, <br /> enjoy access to 1 custom voice, and manage your content <br/>effortlessly without the need for a team.</p>
        </div>
        <hr />
        <div className="p-4">
          <div className="flex items-center gap-1.5 mb-3">
            <img src={check} alt="" />
            <p className="text-[#0F0C18] text-xs font-medium tracking-tight">Flexibility for solo users</p>
          </div>
          <div className="flex items-center gap-1.5 mb-3">
            <img src={check} alt="" />
            <p className="text-[#0F0C18] text-xs font-medium tracking-tight">Create 1-3 profile topic groups</p>
          </div>
          <div className="flex items-center gap-1.5 mb-3">
            <img src={check} alt="" />
            <p className="text-[#0F0C18] text-xs font-medium tracking-tight">Access to 1 custom voice</p>
          </div>
          <div className="flex items-center gap-1.5">
            <img src={check} alt="" />
            <p className="text-[#0F0C18] text-xs font-medium tracking-tight">No team collaboration</p>
          </div>
        </div>
        <hr />
        <div>
          <PrimaryButton label="Subscribe for $20/month" className="rounded-3xl py-2.5 mx-4 absolute w-[347px] bottom-4" black />
        </div>
      </div>
      <div className="w-[380px] h-[500px] rounded-xl bg-[#2A2A36] relative">
        <div className="p-4">
          <div className="flex items-start justify-between">
            <img src={creator} alt="creator" />
            <div>
              <p className="text-white text-base font-medium leading-none tracking-tight">$ 59/month</p>
              <p className="text-[#9392A2] text-xs font-medium text-right mt-1 line-through tracking-tight">$ 69/month</p>
            </div>
          </div>
          <h1 className="text-white text-xl font-medium tracking-tight mt-2">Creator</h1>
          <p className="text-[#ffffff9c] text-xs font-medium leading-[18px] tracking-tight mt-1">Elevate content creation game with our Creator plan. All <br /> the perks of the Individual plan, plus the ability to create <br /> 3-5 profile topic groups, unlock 5 custom voices, and <br /> collaborate with your team.</p>
        </div>
        <div className="w-full h-[1px] bg-[#e1e1e159]" />
        <div className="p-4">
          <div className="flex items-center gap-1.5 mb-3">
            <img src={check} alt="" />
            <p className="text-white text-xs font-medium tracking-tight">All features in the Individual plan</p>
          </div>
          <div className="flex items-center gap-1.5 mb-3">
            <img src={check} alt="" />
            <p className="text-white text-xs font-medium tracking-tight">Create 3-5 profile topic groups</p>
          </div>
          <div className="flex items-center gap-1.5 mb-3">
            <img src={check} alt="" />
            <p className="text-white text-xs font-medium tracking-tight">Unlock 5 custom voices</p>
          </div>
          <div className="flex items-center gap-1.5">
            <img src={check} alt="" />
            <p className="text-white text-xs font-medium tracking-tight">Ability to collaborate with a team</p>
          </div>
        </div>
        <div className="w-full h-[1px] bg-[#e1e1e159]" />
        <div>
          <AmountOf label="Amount of user seat" subLabel="$10/seat" black />
          <AmountOf label="Amount of channels" subLabel="$6/per channel" black />
          <PrimaryButton label="Subscribe for $59/month" className="rounded-3xl py-2.5 mx-4 absolute w-[347px] bottom-4" />
        </div>
      </div>
      <div className="w-[380px] h-[500px] rounded-xl bg-white relative">
        <div className="p-4">
          <div className="flex items-start justify-between">
            <img src={agency} alt="agency" />
            <div>
              <p className="text-[#0F0C18] text-base font-medium leading-none tracking-tight">$ 158/month</p>
              <p className="text-[#9392A2] text-xs font-medium text-right mt-1 line-through tracking-tight">$ 199/month</p>
            </div>
          </div>
          <h1 className="text-[#0F0C18] text-xl font-medium tracking-tight mt-2">Agency</h1>
          <p className="text-[#9392A2] text-xs font-medium leading-[18px] tracking-tight mt-1">Designed for agencies with diverse content needs, our <br /> Agency plan offers unlimited profile connections and <br /> access to multiple custom voices. Manage & optimize <br /> content across all profiles.</p>
        </div>
        <hr />
        <div className="p-4">
          <div className="flex items-center gap-1.5 mb-3">
            <img src={check} alt="" />
            <p className="text-[#0F0C18] text-xs font-medium tracking-tight">All features in the Creator plan</p>
          </div>
          <div className="flex items-center gap-1.5 mb-3">
            <img src={check} alt="" />
            <p className="text-[#0F0C18] text-xs font-medium tracking-tight">No limit on profile connections</p>
          </div>
          <div className="flex items-center gap-1.5 mb-3">
            <img src={check} alt="" />
            <p className="text-[#0F0C18] text-xs font-medium tracking-tight">Access to multiple custom voices</p>
          </div>
          <div className="flex items-center gap-1.5">
            <img src={check} alt="" />
            <p className="text-[#0F0C18] text-xs font-medium tracking-tight">Managing diverse profiles</p>
          </div>
        </div>
        <hr />
        <div>
          <AmountOf label="Amount of user seat" subLabel="$10/seat" />
          <AmountOf label="Amount of channels" subLabel="$6/per channel" />
          <PrimaryButton label="Select and subscribe $159/month" className="rounded-3xl py-2.5 mx-4 absolute w-[347px] bottom-4" black />
        </div>
      </div>
  </div>
  );
}

const UpgradePlan = () => {
  const [pageIndex, setPageIndex] = useState<number>(1);
  const location = useLocation();
  const redirect = useRedirect();

  useEffect(() => {
    if (!location.hash) {
      redirect("#monthly");
    } else if (location.hash === "#monthly") {
      setPageIndex(1);
    } else if (location.hash === "#annualy") {
      setPageIndex(2);
    }
  }, [location.hash, redirect]);
  return (
    <>
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-[7px]">
          <h1 className="text-[#9392A2] text-xs font-medium tracking-tight">Settings</h1>
          <IoIosArrowForward className="text-[#9392A2] text-base font-medium" />
          <h1 className="text-[#9392A2] text-xs font-medium tracking-tight">Upgrade plan</h1>
        </div>
        <div className="flex items-center gap-2">
          <div className="px-3 py-2 bg-white rounded-3xl">
            <p className="text-[#0F0C18] text-xs font-medium tracking-tight">$ 1,345 </p>
          </div>
        </div>
      </div>
      <h1 className="text-[#0F0C18] text-[28px] font-medium leading-9 tracking-tight">Plans</h1>
      <p className="text-[#9392A2] text-sm font-medium mt-2 tracking-tight">Choose the right plan for your needs.</p>
      <div className="mt-6 mb-4">
        <div className="flex items-center gap-[21px]">
          <p onClick={() => {
            setPageIndex(1)
            redirect("#monthly")
            }} className={`${pageIndex === 1 ? "text-[#0F0C18] border-b-2" : "text-[#9392A2] pb-[10px]"} border-[#0F0C18] text-sm font-medium pb-2 cursor-pointer`}>Monthly</p>
          <p onClick={() => {
            setPageIndex(2)
            redirect("#annualy")
            }} className={`${pageIndex === 2 ? "text-[#0F0C18] border-b-2" : "text-[#9392A2] pb-[10px]"} border-[#0F0C18] text-sm font-medium pb-2 cursor-pointer`}>Annualy <span className="text-[#703FF9]">– 20%</span></p>
        </div>
        <div className="w-full h-[1px] bg-[#CDCCD7] -mt-[1.5px]" />
      </div>
      {
        pageIndex === 1 &&
        <Monthly />
      }
      {
        pageIndex === 2 &&
        <Annualy />
      }
    </>
  );
};

export default UpgradePlan;